<template>
    <div class="field grid">
        <label for="procedure" class="col-12 font-bold mb-2 md:col-2 md:mb-0">Procedure: *</label>
        <div class="col-12 md:col-10 flex-column flex-wrap">
            <Dropdown
                id="procedure"
                v-model="selectedProcedure"
                :options="filteredProcedures"
                optionLabel="name"
                optionValue="value"
                placeholder="Select a procedure"
                class="w-full md:w-14rem mr-2"
                :class="{ 'p-invalid': props.isInvalid }"
                @change="emit('update:modelValue', selectedProcedure)"
            />
            <small v-if="props.isInvalid">Procedure field cannot be empty.</small>
            <small v-if="procedureHasValue" class="font-italic">(<span class="font-bold">Note</span>: Switching procedures, you may lose existing information below)</small>
        </div>
    </div>
    <Divider type="dashed" />
</template>

<script setup>
import { ref, onMounted, computed, defineProps, defineEmits } from 'vue';
import { getAllProcedures, getAllSharedProcedures } from '../../enum-helpers';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: {
        type: String,
    },
    isShared: {
        type: Boolean,
    },
    isInvalid: {
        type: Boolean,
    },
    procedureHasValue: Boolean,
});

const selectedProcedure = ref(props.modelValue);

const filteredProcedures = computed(() => {
    return props.isShared ? getAllSharedProcedures() : getAllProcedures();
});

onMounted(() => {
    selectedProcedure.value = props.modelValue;
});
</script>
